import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ------------------------------------
// AUTH
export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));

// dashboard
export const DashboardPage = Loadable(lazy(() => import("../pages/Dashboard")));

// metadata
export const YearPage = Loadable(
  lazy(() => import("../pages/metadata/YearPage"))
);
export const GradePage = Loadable(
  lazy(() => import("../pages/metadata/GradePage"))
);
export const LearningCentrePage = Loadable(
  lazy(() => import("../pages/metadata/LcPage"))
);
export const DepartmentPage = Loadable(
  lazy(() => import("../pages/metadata/DepartmentPage"))
);

// staff
export const NewStaffPage = Loadable(
  lazy(() => import("../pages/staff/NewPage"))
);
export const AllStaffPage = Loadable(
  lazy(() => import("../pages/staff/ListPage"))
);
export const UpdateStaffPage = Loadable(
  lazy(() => import("../pages/staff/UpdatePage"))
);
export const ViewStaffPage = Loadable(
  lazy(() => import("../pages/staff/viewpage"))
);
export const StaffAttendance = Loadable(
  lazy(() => import("../pages/staff/AttendancePage"))
);
export const TempStaffPage = Loadable(
  lazy(() => import("../pages/staff/TempStaffPage"))
);

// paces
export const PaceOrderPage = Loadable(
  lazy(() => import("../pages/paces/PaceOrdersPage"))
);
export const PaceOrderItemsPage = Loadable(
  lazy(() => import("../pages/paces/PaceOrderPage"))
);
export const ReceivePacesPage = Loadable(
  lazy(() => import("../pages/paces/ReceiveOrderPage"))
);
export const StoreListPage = Loadable(
  lazy(() => import("../pages/paces/StoreListPage"))
);
export const PaceListPage = Loadable(
  lazy(() => import("../pages/paces/PaceList"))
);
export const NewPacePage = Loadable(
  lazy(() => import("../pages/paces/NewPace"))
);
export const EditPacePage = Loadable(
  lazy(() => import("../pages/paces/EditPace"))
);

// parents
export const ParentsListPage = Loadable(
  lazy(() => import("../pages/parents/ParentsListPage"))
);
export const ParentViewPage = Loadable(
  lazy(() => import("../pages/parents/ParentViewPage"))
);
export const NewParentPage = Loadable(
  lazy(() => import("../pages/parents/NewParentPage"))
);
export const EditParentPage = Loadable(
  lazy(() => import("../pages/parents/EditParentPage"))
);

// projections
export const ProjectionsPage = Loadable(
  lazy(() => import("../pages/paceprojections/ProjectionsPage"))
);
export const LcListPage = Loadable(
  lazy(() => import("../pages/paceprojections/LcList"))
);
export const StudentListPage = Loadable(
  lazy(() => import("../pages/paceprojections/StudentList"))
);
export const SubjectListPage = Loadable(
  lazy(() => import("../pages/paceprojections/SubjectList"))
);
export const StudentProjectionsPage = Loadable(
  lazy(() => import("../pages/paceprojections/StudentProjections"))
);
export const LCProjectionItemsPage = Loadable(
  lazy(() => import("../pages/paceprojections/LcProjections"))
);
export const SubjectProjectionsPage = Loadable(
  lazy(() => import("../pages/paceprojections/SubjectsProjections"))
);

// Pace Tracking
export const TrackingLcListPage = Loadable(
  lazy(() => import("../pages/pacetracking/LCListPage"))
);
export const TrackingStudentsPage = Loadable(
  lazy(() => import("../pages/pacetracking/StudentsPage"))
);
export const TrackingPaceListPage = Loadable(
  lazy(() => import("../pages/pacetracking/PaceList"))
);

// Error pages
export const Page500 = Loadable(lazy(() => import("../pages/Page500")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// Students
export const ApplicationsPage = Loadable(
  lazy(() => import("../pages/admissions/applications"))
);
export const NewStudentsPage = Loadable(
  lazy(() => import("../pages/students/NewPage"))
);
export const AllStudentsPage = Loadable(
  lazy(() => import("../pages/students/ListPage"))
);
export const UpdateStudentPage = Loadable(
  lazy(() => import("../pages/students/UpdatePage"))
);
export const ViewStudentPage = Loadable(
  lazy(() => import("../pages/students/ViewPage"))
);

// Class lists
export const ClassListsPage = Loadable(
  lazy(() => import("../pages/classlists/ListPage"))
);
export const ClassViewPage = Loadable(
  lazy(() => import("../pages/classlists/ViewPage"))
);

// subjects
export const SubjectsPage = Loadable(
  lazy(() => import("../pages/subjects/listpage"))
);
export const OtherSubjectsPage = Loadable(
  lazy(() => import("../pages/subjects/otherspage"))
);

// pace inventory
export const PaceInventoryPage = Loadable(
  lazy(() => import("../pages/PaceInventory/ListPage"))
);

// Activity Checkin
export const CheckinsPage = Loadable(
  lazy(() => import("../pages/activity-checkin/checkins"))
);
export const ActivityTermsPage = Loadable(
  lazy(() => import("../pages/activity-checkin/terms"))
);
export const ActivityClassListPage = Loadable(
  lazy(() => import("../pages/activity-checkin/classlists"))
);
export const ActivityPage = Loadable(
  lazy(() => import("../pages/activity-checkin/activities"))
);

// finance
export const PaceBillingTermPage = Loadable(
  lazy(() => import("../pages/billing/terms"))
);
export const PaceBillingPage = Loadable(
  lazy(() => import("../pages/billing/pacelists"))
);
export const PaceBillingListItemsPage = Loadable(
  lazy(() => import("../pages/billing/pacelistitems"))
);
